import {inject, Injectable} from '@angular/core';
import {HttpClient, HttpErrorResponse} from '@angular/common/http';
import {catchError, Observable} from 'rxjs';
import {GridGetService, GridServiceParams, GridServiceResponse} from 'src/app/shared/model/page-grid';
import {removeEmptyParams} from 'src/infrastructure/helper/remove-empty-params';
import {getAutocompleteValue} from 'src/infrastructure/helper/autocomplete-helper';
import {AgentData} from './agent.model';

@Injectable({
  providedIn: 'root'
})
export class AgentGridService implements GridGetService<AgentData> {
  private readonly baseUrl = 'dbov2/agent/search';
  private readonly http = inject(HttpClient);
  getItems({filters, page, sort}: GridServiceParams): Observable<GridServiceResponse<AgentData>> {
    const params: Record<string, string | number | boolean> = {
      pageSize: page?.pageSize || 25,
      pageNumber: (page?.pageIndex || 0) + 1,
      propertyName: sort?.active || '',
      orderKey: sort?.direction || '',
      excludeTotalsColumns: 'currentSplitRate,splitRate,marginPercentage,agentSplit,agencySplit',
      includeDataSource: true,
      agentName: getAutocompleteValue(filters?.['agentName']),
      agentCode: getAutocompleteValue(filters?.['agentCode']),
      dataSourceId: filters?.['dataSourceId'] ?? '',
    };
    removeEmptyParams(params);
    
    return this.http.get<GridServiceResponse<AgentData>>(`${this.baseUrl}`, { params: {...params} })
      .pipe(catchError((error: HttpErrorResponse) => {
        throw new Error(error?.message || 'Server error');
      }));
  }
}